import { render } from "./ZapiEstadoSync.vue?vue&type=template&id=b69d7d80"
import script from "./ZapiEstadoSync.vue?vue&type=script&lang=js"
export * from "./ZapiEstadoSync.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__